function reklamaPopUp () {
    if(getCookie('reklamaPopUp') === undefined) {
        $.fancybox.open({
            src: '#reklama-pop-up',
            type: 'inline',
            afterClose  : function() {
                setCookie('reklamaPopUp', true, 1);
            }
        });
    }
}
reklamaPopUp();